import styled from 'styled-components';
import { device } from '../../../styles/devices';
import type { ThemeProps } from '../../../types';

export const Base = styled.p`
  font-family: 'Audi Type';
  font-size: 16px;
  line-height: 24px;
  cursor: default;
`;

export const Copy = styled(Base)`
  width: 90%;
  margin-bottom: 6px;
  @media ${device.tablet} {
    margin-bottom: 0;
  }
`;

export const SeeDetailsWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  @media ${device.tablet} {
    display: none;
  }
`;

export const SeeDetails = styled(Base)`
  margin-right: 10px;
  font-size: 12px;
  line-height: 17px;
  color: #4c4c4c;
  @media ${device.tablet} {
    display: none;
  }
`;

export const EquipmentOption = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Audi Type';
  padding: 20px 24px;
  background: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[800]};
  position: relative;
  margin-bottom: 1px;
  &:focus {
    outline: 2px solid #4c8bf5;
    outline: 5px auto -webkit-focus-ring-color;
  }
  @media ${device.tablet} {
    &:hover,
    &:focus {
      z-index: 10;
      margin-left: 8px;
      margin-right: 0px;
      font-weight: bold;
    }
    margin-bottom: 5px;
    position: static;
    min-width: 450px;
    max-width: 500px;
    margin-right: 24px;
    height: 120px;
    cursor: pointer;
  }
`;

export const CopyWrap = styled.div`
  flex: 1 1 50%;
  @media ${device.tablet} {
    flex: 1 2 50%;
  }
`;

export const ChevronIconWrap = styled.div`
  &:hover {
    padding-left: 3px;
    transition: 300ms;
  }
`;

export const DetailsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ImageHolder = styled.div`
  display: flex;
  justify-self: flex-end;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  max-width: 127px;
  @media ${device.tablet} {
    margin-right: 10%;
    margin-left: 0;
  }
`;

export const EquipmentImage = styled.img`
  width: 100%;
  max-height: 80px;
  vertical-align: middle;
`;
